import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column flex-sm-row" },
        [
          _c(
            VAutocomplete,
            _vm._b(
              {
                staticClass: "mt-5 mt-sm-0",
                attrs: {
                  label: "Choose a saved search",
                  items: _vm.savedParameters,
                  "item-text": "name",
                  "item-value": "id",
                  "return-object": "",
                  clearable: "",
                },
                model: {
                  value: _vm.selectedParams,
                  callback: function ($$v) {
                    _vm.selectedParams = $$v
                  },
                  expression: "selectedParams",
                },
              },
              "v-autocomplete",
              _vm.$attrs,
              false
            )
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-space-around mt-3 mt-sm-0" },
            [
              _vm.vuexName && !_vm.selectedParams
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-0 ml-sm-5 my-auto",
                      on: { click: _vm.openSaveDialog },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.base.saveSearch")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.selectedParams
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-5 ml-sm-5 my-auto",
                      on: {
                        click: function ($event) {
                          return _vm.loadParams()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.load")) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.selectedParams
                ? _c(
                    VMenu,
                    {
                      attrs: { "offset-y": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "mt-3 ml-3",
                                        attrs: { icon: "" },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_c(VIcon, [_vm._v("mdi-dots-vertical")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3578405134
                      ),
                    },
                    [
                      _c(
                        VList,
                        { staticClass: "pa-2" },
                        [
                          _vm.vuexName
                            ? _c(
                                VListItem,
                                { on: { click: _vm.openSaveDialog } },
                                [
                                  _c(VListItemContent, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedParams
                                            ? _vm.$vuetify.lang.t(
                                                "$vuetify.base.updateSearch"
                                              )
                                            : _vm.$vuetify.lang.t(
                                                "$vuetify.base.saveSearch"
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            VListItem,
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.remove(_vm.selectedParams)
                                },
                              },
                            },
                            [
                              _c(VListItemContent, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.base.delete"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: {
            "max-width": "600px",
            width: "80%",
            fullscreen: _vm.$vuetify.breakpoint.xsOnly,
          },
          model: {
            value: _vm.saveDialog,
            callback: function ($$v) {
              _vm.saveDialog = $$v
            },
            expression: "saveDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.base.saveSearch")) +
                    " "
                ),
              ]),
              _c(
                VCardText,
                [
                  _c(VTextField, {
                    attrs: { label: "Assign a name to this search" },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCardActions,
                { staticClass: "py-5" },
                [
                  _c(VSpacer),
                  _vm.selectedParams
                    ? _c(
                        VBtn,
                        {
                          on: {
                            click: function ($event) {
                              return _vm.updateParams(_vm.selectedParams)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.update")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _c(VBtn, { on: { click: _vm.saveParams } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$vuetify.lang.t("$vuetify.base.save")) +
                            " "
                        ),
                      ]),
                  _c(
                    VBtn,
                    {
                      on: {
                        click: function ($event) {
                          _vm.saveDialog = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.cancel")) +
                          " "
                      ),
                    ]
                  ),
                  _c(VSpacer),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }